/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { twMerge } from 'utilities/src/twMerge';

import addUrlHostName from '../../../utils/addUrlHostname';
import { IconEnum } from '../../../data/MenuItem';

import { flyoutIcons } from '../../Flyout_deprecated/_icons';
import PurifiedText from '../../PurifiedText';

import { MobileFlyoutDropdownMenuProps } from './_props';

import useMobileFlyoutDropdownMenuTheme from './themes';

function MobileFlyoutDropdownMenu({ mobileMenuActiveItem, subMenuItem, hasIcon }: MobileFlyoutDropdownMenuProps) {
  const {
    dropdownItemWrapperClasses,
    dropdownItemLinkClasses,
    dropdownItemLinkTextClasses,
    dropdownItemLinkNameClasses,
    dropdownItemLinkDescriptionClasses,
    dropdownItemLinkFeaturedClasses,
  } = useMobileFlyoutDropdownMenuTheme();

  if (subMenuItem.id !== mobileMenuActiveItem) return null;
  if (subMenuItem.children.length === 0) return null;

  return (
    <div className={dropdownItemWrapperClasses}>
      {subMenuItem.description && (
        <PurifiedText as="p" className="site-paragraph-m text-site-neutrals-600 w-[90%] [&_a]:underline">
          {subMenuItem.description}
        </PurifiedText>
      )}

      {subMenuItem.children.map((subItem) => {
        const isFeaturedLink = subItem.id === subMenuItem.children.at(-1)?.id && subItem.label.includes('All ');

        return (
          <div key={subItem.id} className={dropdownItemLinkClasses}>
            {hasIcon && subItem.icon && flyoutIcons.get(IconEnum[subItem.icon])}

            <div className={dropdownItemLinkTextClasses}>
              <a
                href={`${addUrlHostName(subItem.path)}?nav=old`}
                className={twMerge({
                  [dropdownItemLinkNameClasses]: hasIcon,
                  [dropdownItemLinkDescriptionClasses]: !hasIcon,
                  [dropdownItemLinkFeaturedClasses]: isFeaturedLink,
                })}
              >
                {subItem.label}
              </a>

              {hasIcon && <span className={dropdownItemLinkDescriptionClasses}>{subItem.description}</span>}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default MobileFlyoutDropdownMenu;
